import { ReactNode } from 'react'
import { ApiError } from 'features/common'
import { Box } from '@mui/material'
import { CustomErrorBoundary } from 'features/errors/ui/CustomErrorBoundary'
import BasicPageContainer from '../BasicPageContainer'

interface BasicPageErrorProps {
  children?: ReactNode
  tight?: boolean
  hasError?: ApiError | null // TODO VVG: hasError is not boolean
  contentClassName?: string
}

function BasicPageError({ children, tight, hasError, contentClassName }: BasicPageErrorProps) {
  return (
    <BasicPageContainer className={contentClassName} tight={tight}>
      <CustomErrorBoundary hasError={hasError}>
        <Box pb={8}>{children}</Box>
      </CustomErrorBoundary>
    </BasicPageContainer>
  )
}

export default BasicPageError
